var basePageURL = "/pages/engagement-rings",
  collectionURL = "/collections/engagement-rings-australia";

var selectors = {
  range: ".range-item",
  summary: ".summary-c-select__btn",
  tagsForm: ".filter-form",
  filterFormLabel: ".filter-form .tag__checkbox-wrapper",
  filterFormSortBy: ".filter-form .sort-by",
  priceRange: ".price-range",
};
let apiUrl = "https://kavalri-app-dev.herokuapp.com",
  apiKey = "valid_api_key";
// "yellow/orange",
//       "pink",
//       "blue",
//       "green",
//       "blue-green",
//       "brown",
//       "orange-pink",
const baseFilter = {
    shapes: [],
    carat_from: "0.50",
    carat_to: "10.00",
    price_from: 0,
    price_to: 200000,
    color_from: "d",
    color_to: "j",
    colors: [
      
    ],
    symmetry_from: "excellent",
    symmetry_to: "very-good",
    clarity_from: "fl",
    clarity_to: "si1",
    polish_from: "excellent",
    polish_to: "very-good",
    cut_to: "very-good",
    cut_from: "ideal",
    length_width_ratio_from: '1.00',
    length_width_ratio_to: '2.95',
    lab: "",
    is_sustainably_rated: false,
    location: "all",
  } 
document.addEventListener("alpine:init", () => {
  Alpine.store("diamond", {
    express: false,
    step: 1,
    showOtherStep: false,
    leftDiamond:  localStorage.getItem("diamond-selected-left-item")
      ? JSON.parse(localStorage.getItem("diamond-selected-left-item"))
      : {},
    selectedItem: localStorage.getItem("diamond-selected-item")
      ? JSON.parse(localStorage.getItem("diamond-selected-item"))
      : {},
    recentlyItem: sessionStorage.getItem("diamond-recently-items") && sessionStorage.getItem("diamond-recently-items")  != "[null]" ?JSON.parse(sessionStorage.getItem("diamond-recently-items")): [],
    observer: {},
    headerFilter: false,
    showProgress: false,
    type: "lab",
    is_colored: false,
    loading: false,
    get currentItem() {
      return this.recentlyItem.length > 0?this.recentlyItem[this.recentlyItem.length - 1]: {}
    },
    selectProduct(id,product) {
      // 
      let recently = []
      try{
        recently = sessionStorage.getItem("diamond-recently-items")&& sessionStorage.getItem("diamond-recently-items")  != "[null]" ?JSON.parse(sessionStorage.getItem("diamond-recently-items")): [];
        recently = recently.filter(item => item.id != id);
      }catch(e){
        sessionStorage.removeItem("diamond-recently-items");
        recently = []
      }finally{
        recently.push(product)
      }
      sessionStorage.setItem("diamond-recently-items",JSON.stringify(recently))
      this.recentlyItem = recently
      if (this.step != 1 && this.express && !product) {
          window.location.href =
            '/collections/' + this.selectedItem.collection_handle + '/products/' + this.selectedItem.handle
      }else{
        window.location.href = basePageURL + "?view=diamond-view&diamond="+this.type+"&is_colored="+this.is_colored+"&id=" + id+(this.express?"&path=express":"");
      }
    },
    init() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("diamond")) {
        this.type = urlParams.get("diamond");
      }


      if (urlParams.get("is_colored")) {
        this.is_colored = urlParams.get("is_colored") == "true";
      }


      if (this.type == "natural"){
        baseFilter.clarity_to = "si2"
        baseFilter.color_to = "m"
      }
      if(!urlParams.get("local") && urlParams.get("view") == "diamond-list"){
         localStorage.removeItem("diamond-filter")
         localStorage.removeItem("diamond-filter-type")
         localStorage.removeItem("diamond-selected-item")
         this.selectedItem = {}
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            this.headerFilter = !entry.isIntersecting;
          });
        },
        { rootMargin: "0px 0px 0px 0px" }
      );
    },
    selectItem(diamondItem) {
      this.loading = true;
      if(this.express && this.selectedItem.variantId){
        const bodyData = { uid: diamondItem.uid };
        fetch(apiUrl + "/api/product", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-api-key": apiKey,
          },
          body: JSON.stringify(bodyData),
        })
          .then(response => response.json())
          .then(responseJson => {
            let submitItems = [
                    {
                      quantity: 1,
                      id: responseJson.variant_id,
                    },
                    {
                      quantity: 1,
                      id: this.selectedItem.variantId,
                      properties: {
                        'Ring Size': this.selectedItem.ringSize,
                      },
                    }
                  ];
            if(this.showOtherStep){
              if(this.leftDiamond && this.leftDiamond.variant_id){
                   submitItems = [
                    {
                      quantity: 1,
                      id: this.leftDiamond.variant_id,
                    },
                    {
                      quantity: 1,
                      id: responseJson.variant_id,
                    },
                    {
                      quantity: 1,
                      id: this.selectedItem.variantId,
                      properties: {
                        'Ring Size': this.selectedItem.ringSize,
                      },
                    }
                  ];
              }else{
                localStorage.setItem(
                  "diamond-selected-left-item",
                  JSON.stringify(responseJson)
                );
                this.redirectURL(21, basePageURL, "list");
                return;
              }
            }
            setTimeout(() => {
              $.ajax({
                dataType: 'json',
                url: '/cart/add.js',
                method: 'POST',
                data: {
                  items: submitItems,
                },
                success: () => {
                  localStorage.removeItem("diamond-selected-left-item");
                  localStorage.removeItem("diamond-selected-item");
                  window.location.href = '/cart'
                },
                error: data => {
                  this.loading = false
                  // remove
                  localStorage.removeItem("diamond-selected-left-item");
                  localStorage.removeItem("diamond-selected-item");
                  alert(data.responseJSON.description)
                },
              })
            },4000)
          })
      }else{
        const bodyData = { uid: diamondItem.uid };
        fetch(apiUrl + "/api/product", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-api-key": apiKey,
          },
          body: JSON.stringify(bodyData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            this.selectedItem = Object.assign(diamondItem, responseJson);
            localStorage.setItem(
              "diamond-selected-item",
              JSON.stringify(this.selectedItem)
            );
            this.redirectURL(2, collectionURL, "list");
          }).catch((error) => {
            this.loading = false
          });
      }
        
    },
    redirectURL(step, link, type) {
      if (link.indexOf("?") > -1) {
        link = link + "&";
      } else {
        link = link + "?";
      }
      if (step == 1) {

        localStorage.removeItem("diamond-selected-left-item");
        if(this.express){
          history.go(-1);
        }else{
          window.location.href =
            link +
            "&local=true&view=diamond-list&diamond=" +
            this.type +
            "&is_colored=" +
            this.is_colored;
        }
      } else if (step == 2) {
        if (type == "list") {
          let shape1 = this.selectedItem.shape.toUpperCase();
          let shape2 =
            this.selectedItem.shape.charAt(0).toUpperCase() +
            this.selectedItem.shape.slice(1);
          window.location.href =
            link +
            "view=diamond&diamond=" +
            this.type +
            "&is_colored=" +
            this.is_colored +
            "&filter.p.tag=" +
            this.selectedItem.shape +
            "&filter.p.tag=" +
            shape1 +
            "&filter.p.tag=" +
            shape2;
          }else {
            window.location.href =
              link +
              "view=diamond&diamond=" +
              this.type +
              "&is_colored=" +
              this.is_colored;
          }
      } else if (step == 21){
          history.go(-1);

          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
      }
    },

    removeItem() {
      // const collection_handle = this.selectedItem.collection_handle;
      this.selectedItem = {};
      localStorage.removeItem("diamond-selected-item");
      this.redirectURL(1, basePageURL, );
    },
  });
  window["ThemeSection_DiamondList"] = (settings) => {
    if (settings.api_endpoint == "live") {
      (apiUrl = "https://kavalri-app.herokuapp.com"),
        (apiKey = "hamei3983jhPIhq7hLJo93hqmvNoC762");
    }

    return {
      flawless_diamond_range: false,
      diamondUrl: "",
      diamondPopup: false,
      summaryOpen: false,
      openFilter: false,
      mobileFilterShow: false,
      filterName: "",
      isCompare: false,
      isRecently: false,
      summaryType: localStorage.getItem("diamond-summary-type") || "grid",
      page: { page: 1, max_results: 24 },
      order: {
        "order_by": "price",
        "order_type": "asc"
       },
      filter: {},
      filterShowMore: false,
      total_items: 0,
      selectedItems: [],
      data: [],
      listAbortController: null,
      sidebar: {},
      initDrawerBoolean: false,
      infoText: '',
      recentlyItems: [],
      drawerOpen() {
        document.querySelector("html").classList.add("filter-drawer-open");
      },
      drawerClose() {
        document.querySelector("html").classList.remove("filter-drawer-open");
      },

      clearFilter: function () {
        let drawerBtn = document.querySelector(
          '.collection-sidebar button[data-drawer-name = "' +
            this.filterName +
            '"]'
        );
        $(drawerBtn).trigger("click.collapsible");
        this.filterName = "";
      },
      selectedFilter(filterName) {
        this.filterName = filterName;
      },
      selectAll() {
        if (this.filterName) {
          const checkboxs = document
            .querySelector(
              '.collection-sidebar button[data-drawer-name="' +
                this.filterName +
                '"]'
            )
            .closest(".collection-sidebar__group")
            .querySelectorAll('input[type="checkbox"]:not(:checked)');
          checkboxs.forEach(function (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event("change"));
          });
        }
      },

      get filterdeTags() {
        let combinedArray = [];
        
        for (let key in this.filter) {
          if (key == "shapes" || key == "colors") {
            if (Array.isArray(this.filter[key]) && this.filter[key].length > 0) {
              combinedArray = combinedArray.concat(
                this.filter[key].map((item) => key + "--" + item)
              );
            }
          } else if (key == "lab" && this.filter[key]){
              combinedArray.push("lab--"+ this.filter[key])
          } else if (key == "is_sustainably_rated" && this.filter[key]){
              combinedArray.push("is_sustainably_rated--is sustainably rated")
          }else{
            if(key.indexOf("_from") > -1){
              const title = key.replace("_from","")
              const to = title + "_to"
              if(this.filter[key] != baseFilter[key] || this.filter[to] != baseFilter[to]){
               
                combinedArray.push(key+"--"+title+":"+this.filter[key] + "~" + this.filter[to])
              }
            }
          }
          
        }
        return combinedArray;
      },
      clearFilterTag(isFirst) {
        const urlParams = new URLSearchParams(window.location.search);
        let clarity_to = "si1", color_to = "j"
        if (urlParams.get("diamond") == "natural") {
          clarity_to = "si2"
          color_to = "m"
        }
        if (this.$store.diamond.is_colored) {
          this.filter = {
            shapes: [],
            carat_from: "0.50",
            carat_to: "10.00",
            price_from: 0,
            price_to: 200000,
            colors: [
            ],
            symmetry_from: "excellent",
            symmetry_to: "very-good",
            clarity_from: "fl",
            clarity_to: clarity_to,
            polish_from: "excellent",
            polish_to: "very-good",
            cut_to: "very-good",
            cut_from: "ideal",
            length_width_ratio_from: '1.00',
            length_width_ratio_to: '2.95',
            lab: "",
            is_sustainably_rated: false,
            location: "all",
          };
        } else {
          this.filter = {
            shapes: [],
            carat_from: "0.50",
            carat_to: "10.00",
            price_from: 0,
            price_to: 200000,
            color_from: "d",
            color_to: color_to,
            symmetry_from: "excellent",
            symmetry_to: "very-good",
            clarity_from: "fl",
            clarity_to: clarity_to,
            polish_from: "excellent",
            polish_to: "very-good",
            cut_to: "very-good",
            cut_from: "ideal",
            length_width_ratio_from: '1.00',
            length_width_ratio_to: '2.95',
            lab: "",
            is_sustainably_rated: false,
            location: "all",
          };
        }
        if(!isFirst){
           this.reChangeRange()
        }
      },
      removeFilterTag(tagItem) {
        let [key, value] = tagItem.split("--");
        if(!Array.isArray(this.filter[key])){
          if(key.indexOf("_from") > -1){
            const title = key.replace("_from","")
            const to = title + "_to"
            this.filter[key] = baseFilter[key]
            this.filter[to] =  baseFilter[to]
            const $filter =  $(".range-filter[data-value-1='"+key+"']");
            let times = $filter.data('times')
            $filter.slider('values', [baseFilter[key] / (times || 1), baseFilter[to] / (times || 1)]);
          }else{
            this.filter[key] = baseFilter[key]
          }
        }else{
          this.filter[key] = this.filter[key].filter((item) => item !== value);
        }
      },

      get tableItems() {
        if(this.isCompare){
          return this.selectedItems
        }else if(this.isRecently){
          return this.recentlyItems;
        }else{
          return this.data
        }
      },
      get summarySelected(){
        if(!this.order.order_by){
          return 'Relevance'
        }else if(this.order.order_by == 'price'){
          if(this.order.order_type == 'asc'){
            return 'Price:Low to High'
          }else{
            return 'Price:High to Low'
          }
        }else if(this.order.order_by == 'carat'){
          if(this.order.order_type == 'asc'){
            return 'Carat:Low to High'
          }else{
            return 'Carat:High to Low' 
          }
        }
      },
      updateSummaryType(summaryType) {
        this.summaryType = summaryType;
        localStorage.setItem("diamond-summary-type", this.summaryType);
      },
      init() {


        this.clearFilterTag(true)
        this.$store.diamond.step = 1;
        this.initSummary();
        this.initWatch();
        this.$nextTick(() => {
          if (this.$store.diamond.type == "natural"){
            this.filter = Object.assign(this.filter, {
              carat_from: "0.90",
              carat_to: "2.5",
              color_from: "d",
              color_to: "h",
              clarity_from: "if",
              clarity_to: "si1"
            });
          }

          if (this.$store.diamond.type == "lab" && !this.$store.diamond.is_colored){
            this.filter = Object.assign(this.filter, {
              carat_from: "1.4",
              carat_to: "8.0",
              color_from: "d",
              color_to: "f",
              clarity_from: "vvs1",
              clarity_to: "vs2"
            });
          }

          if (this.$store.diamond.type == "lab" && this.$store.diamond.is_colored){
             this.filter = Object.assign(this.filter, {
              carat_from: "1.2",
              carat_to: "2.5",
              clarity_from: "vvs1",
              clarity_to: "vs2"
            });
          }
           if(localStorage.getItem("diamond-filter") && localStorage.getItem("diamond-filter-type") == (this.$store.diamond.type +"-"+ this.$store.diamond.is_colored)){
             this.filter = JSON.parse(localStorage.getItem("diamond-filter"))
           }
          this.initRange();
          this.initSlidebar();
          this.initDrawer();
          const urlParams = new URLSearchParams(window.location.search)
          const diamond_shape = urlParams.get("diamond-shape");
          if(diamond_shape){
            if(diamond_shape == 'cushion'){
              this.filter.shapes = ["cushion", "elongated-cushion"]
            }else{
              this.filter.shapes = [diamond_shape]
            }
          }
          const diamond_sustainably_rated = urlParams.get("sustainably_rated");
          if(diamond_sustainably_rated){
            this.filter.is_sustainably_rated = !!diamond_sustainably_rated
          }
          if (urlParams.get('path') === 'express') {
            this.$store.diamond.express = true
            const express_product_handle = urlParams.get('product_handle')
            const express_collection_handle = urlParams.get('collection_handle')
            const express_selected_variant_id = urlParams.get('selected_variant_id')
            const express_ring_size = urlParams.get('ring_size')
            const express_type = urlParams.get("diamond");
            this.filter.type = express_type
            fetch(`https://kavalri.com.au/products/${express_product_handle}.json`)
              .then(response => response.json())
              .then(data => {
                // The product data is now stored in `data.product`
                let product = data.product
                const selectedVariant = product.variants.find(
                  variant => variant.id.toString() === express_selected_variant_id
                )
  
                const selectedImage = product.images.find(image =>
                  image.variant_ids.includes(parseInt(express_selected_variant_id))
                )
  
                product.product_title = product.title
                product.price = selectedVariant.price
                product.image_url = selectedImage.src
                product.variant_title = selectedVariant.title
                product.variantId = express_selected_variant_id
                product.ringSize = express_ring_size
                product.collection_handle = express_collection_handle
                product.type = "express"
  
                if(localStorage.getItem("diamond-selected-left-item")){
                  this.$store.diamond.step = 21
                  this.$store.diamond.leftDiamond = JSON.parse(localStorage.getItem("diamond-selected-left-item"));
                }else{
                  this.$store.diamond.step = 2 
                }
                localStorage.setItem(
                  "diamond-selected-item",
                  JSON.stringify(product)
                );
                this.$store.diamond.selectedItem = product;
  
                // const tags = product.tags.split(',')
                const tags = product.tags.toLowerCase()
                if(tags && tags.toLowerCase().indexOf("toietmoi")>-1){
                  if(this.$store.diamond.step == 2){
                    //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                    // Filter the label to determine whether it is selected by default
                    if (tags.indexOf('left-stone-round') > -1) {
                      this.filter.shapes = ['round']
                    } else if (tags.indexOf('left-stone-oval') > -1) {
                      this.filter.shapes = ['oval']
                    } else if (tags.indexOf('left-stone-square') > -1) {
                      this.filter.shapes = ['square']
                    } else if (tags.indexOf('left-stone-cushion') > -1) {
                      this.filter.shapes = ['cushion']
                    } else if (tags.indexOf('left-stone-trilliant') > -1) {
                      this.filter.shapes = ['trilliant']
                    } else if (tags.indexOf('left-stone-emerald') > -1) {
                      this.filter.shapes = ['emerald']
                    } else if (tags.indexOf('left-stone-pear') > -1) {
                      this.filter.shapes = ['pear']
                    } else if (tags.indexOf('left-stone-radiant') > -1) {
                      this.filter.shapes = ['radiant']
                    } else if (tags.indexOf('left-stone-marquise') > -1) {
                      this.filter.shapes = ['marquise']
                    }
                  }else{
                    //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                    // Filter the label to determine whether it is selected by default
                    if (tags.indexOf('right-stone-round') > -1) {
                      this.filter.shapes = ['round']
                    } else if (tags.indexOf('right-stone-oval') > -1) {
                      this.filter.shapes = ['oval']
                    } else if (tags.indexOf('right-stone-square') > -1) {
                      this.filter.shapes = ['square']
                    } else if (tags.indexOf('right-stone-cushion') > -1) {
                      this.filter.shapes = ['cushion']
                    } else if (tags.indexOf('right-stone-trilliant') > -1) {
                      this.filter.shapes = ['trilliant']
                    } else if (tags.indexOf('right-stone-emerald') > -1) {
                      this.filter.shapes = ['emerald']
                    } else if (tags.indexOf('right-stone-pear') > -1) {
                      this.filter.shapes = ['pear']
                    } else if (tags.indexOf('right-stone-radiant') > -1) {
                      this.filter.shapes = ['radiant']
                    } else if (tags.indexOf('right-stone-marquise') > -1) {
                      this.filter.shapes = ['marquise']
                    }
                  }
                }else{
                  //round,oval,square ,cushion,trilliant,emerald,pear,radiant,marquise
                  // Filter the label to determine whether it is selected by default
                  if (tags.indexOf('round') > -1) {
                    this.filter.shapes = ['round']
                  } else if (tags.indexOf('oval') > -1) {
                    this.filter.shapes = ['oval']
                  } else if (tags.indexOf('square') > -1) {
                    this.filter.shapes = ['square']
                  } else if (tags.indexOf('cushion') > -1) {
                    this.filter.shapes = ['cushion']
                  } else if (tags.indexOf('trilliant') > -1) {
                    this.filter.shapes = ['trilliant']
                  } else if (tags.indexOf('emerald') > -1) {
                    this.filter.shapes = ['emerald']
                  } else if (tags.indexOf('pear') > -1) {
                    this.filter.shapes = ['pear']
                  } else if (tags.indexOf('radiant') > -1) {
                    this.filter.shapes = ['radiant']
                  } else if (tags.indexOf('marquise') > -1) {
                    this.filter.shapes = ['marquise']
                  }
                }
                this.getList()
              })
          } else {
            this.getList()
          }
        });

        window.on("resize", theme.utils.debounce(500, this.initDrawer));


        // 
        const locationSelects = document.querySelectorAll(".location-selects li")
        locationSelects.forEach((el) => {
          el.addEventListener("click", (event) => {
            const locationItem = el.dataset.location
            this.isCompare = false;
            this.isRecently = false;
            this.infoText = ''
            if(locationItem == "compare"){
              this.isCompare = true;
              if(this.selectedItems.length == 0){
                this.infoText = 'To compare diamonds please select them from the "Results" tab.'
              }
            }else if(locationItem == "recently"){
              this.isRecently = true
              // 
              this.recentlyItems = sessionStorage.getItem("diamond-recently-items")?JSON.parse(sessionStorage.getItem("diamond-recently-items")): [];
              if(this.recentlyItems.length == 0){
                this.infoText = 'No data found...'
              }
            }else{
              this.filter.location = locationItem
            }
            locationSelects.forEach((item) =>
              item.classList.remove("active")
            );
            el.classList.add("active");
          });
        })



      },
      changeSelected(product) {
        let array = this.selectedItems;
        array.findIndex((el) => el.id === product.id) !== -1
          ? array.splice(
              array.findIndex((el) => el.id === product.id),
              1
            )
          : array.push(product);
        if(array.length == 0){
          this.isCompare = false
        }
        this.selectedItems = array;
      },

      initSlidebar: function () {
        this.sidebar = new theme.CollectionSidebar(this.$refs.diamonds);
        this.sidebar.init();

        let that = this;
        $('#diamonds-filters .range-filter').each(function(){
          var $filter = $(this),
              var1 = $filter.data('value-1'),
              var2 = $filter.data('value-2'),
              $input1 = $filter.parent().find('input[data-value-1]'),
              $input2 = $filter.parent().find('input[data-value-2]'),
              min = parseFloat($filter.data('min')),
              max = parseFloat($filter.data('max')),
              times = $filter.data('times'),
              toFixed = (times ? (times == '0.1' ? 1 : 2) : null),
              values = $filter.data('values'),
              Min0 = min * (times || 1),
              Max0 = max * (times || 1);

          if ($input1 && $input2) {
            if (times) {
              if(that.filter[var1]){
               $input1.val(that.filter[var1]);
              }else{
                $input1.val(Min0.toFixed(toFixed));
              }
              if(that.filter[var2]){
               $input2.val(that.filter[var2]);
              }else{
                $input2.val(Max0.toFixed(toFixed));
              }
            } else if (values) {

            } else {
              if(that.filter[var1]){
               $input1.val(that.filter[var1]);
              }else{
                $input1.val(min);
              }
              if(that.filter[var2]){
               $input2.val(that.filter[var2]);
              }else{
                $input2.val(max);
              }
            }
            $input1.off('change').change(function(e) {
              this.value = parseFloat(this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')).toFixed(toFixed);
              var float_value = parseFloat(this.value);
              if (isNaN(this.value) || float_value < Min0) {
                this.value = Min0.toFixed(toFixed);
              }
              if (float_value > that.filter[var2] && float_value <= Max0) {
                that.filter[var2] = float_value;
                that.filter[var1] = float_value;
                $input2.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2]] / (times || 1));
              } else
              if (float_value > that.filter[var2] && float_value > Max0) {
                this.value = Max0.toFixed(toFixed);
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input2.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else {
                that.filter[var1] = float_value;
                $filter.slider('values', 0, that.filter[var1] / (times || 1));
              }
              if (this.value > min) {
                $clear.toggleClass('visible', true);
              }
            });

            $input2.off('change').change(function(e) {
              this.value = parseFloat(this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')).toFixed(toFixed);
              var float_value = parseFloat(this.value);
              if (isNaN(this.value) || float_value > Max0) {
                this.value = Max0.toFixed(toFixed);
              }
              if (float_value < that.filter[var1] && float_value >= Min0) {
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input1.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else
              if (float_value < that.filter[var2] && float_value < Min0) {
                this.value = Min0.toFixed(toFixed);
                that.filter[var1] = float_value;
                that.filter[var2] = float_value;
                $input1.val(this.value);
                $filter.slider('values', [that.filter[var1] / (times || 1), that.filter[var2] / (times || 1)]);
              } else {
                that.filter[var2] = float_value;
                $filter.slider('values', 1, that.filter[var2] / (times || 1));
              }
            });
          }

          const startFilter = that.filter[var1]? values&&values.length > 0? values.indexOf(that.filter[var1]):that.filter[var1]/(times?times:1):min;
          const endFilter = that.filter[var2]? values&&values.length > 0? values.indexOf(that.filter[var2]):that.filter[var2]/(times?times:1):max;
          $filter.slider({
            range: true,
            min: min,
            max: max,
            values: [startFilter, endFilter],
            stop: function( event, ui ) {
              if (times) {
                that.filter[var1] = ((ui.values[0] * (times != null ? times : 1)).toFixed(toFixed));
                that.filter[var2] = ((ui.values[1] * (times != null ? times : 1)).toFixed(toFixed));
              } else if (values) {
                that.filter[var1] = values[ui.values[0]];
                that.filter[var2] = values[ui.values[1]];
              } else {
                that.filter[var1] = ui.values[0];
                that.filter[var2] = ui.values[1];
              }
            },
            slide: function( event, ui ) {
              if ($input1 && $input2) {
                if (times) {
                  $input1.val((ui.values[0] * (times != null ? times : 1)).toFixed(toFixed));
                  $input2.val((ui.values[1] * (times != null ? times : 1)).toFixed(toFixed));
                } else
                if (values) {

                } else {
                  $input1.val(ui.values[0]);
                  $input2.val(ui.values[1]);
                }
              }
            }
          });
        });
      },
      reChangeRange: function(){
          this.initSlidebar();
          const rangeEls = document.querySelectorAll(selectors.range);
          rangeEls.forEach((el) => {
              const sliderEl = el.querySelector(".range__slider");
              const minName = el.dataset.minName;
              const maxName = el.dataset.maxName;
              if (sliderEl && sliderEl.noUiSlider) {
                let minValue = this.filter[minName];
                let maxValue = this.filter[maxName];
                if(el.dataset.values){
                  const dataValues = el.dataset.values? eval(el.dataset.values) : [];
                  minValue = dataValues.indexOf(this.filter[minName])
                  maxValue = dataValues.indexOf(this.filter[maxName]);
                }

                sliderEl.noUiSlider.updateOptions({
                  start: [minValue,maxValue],
                });
              }
          });
      },
      initWatch: function () {


         this.$watch("$store.diamond.selectedItem", (value)=>{
          if(value.tags && value.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.diamond.showOtherStep = true;
          }
        });


        this.$watch("order", (value) => {
          this.getList();
        });
        this.$watch("filter", (value) => {
          localStorage.setItem("diamond-filter", JSON.stringify(value));
          localStorage.setItem("diamond-filter-type", this.$store.diamond.type+"-"+this.$store.diamond.is_colored);
          this.getList();
         
        });

        this.$watch("flawless_diamond_range", (value)=> {
          if(value){
            let baseParams = {
              "carat_from": "1.20",
              "carat_to": "10.00",
              "color_from": "d",
              "color_to": "d",
              "symmetry_from": "excellent",
              "symmetry_to": "excellent",
              "clarity_from": "fl",
              "clarity_to": "if",
              "polish_from": "excellent",
              "polish_to": "excellent"
            };
            this.filter = Object.assign(this.filter,baseParams)
            /**
            if(params.carat_from == baseFilter.carat_from){
              baseParams.carat_from = "1.20"
            }
            if(params.carat_to == baseFilter.carat_to){
              baseParams.carat_to = "10.00"
            }
            if(params.color_from == baseFilter.color_from){
              baseParams.color_from = "d"
            }
            if(params.color_to == baseFilter.color_to){
              baseParams.color_to = "d"
            }
            if(params.symmetry_from == baseFilter.symmetry_from){
              baseParams.symmetry_from = "excellent"
            }
            if(params.symmetry_to == baseFilter.symmetry_to){
              baseParams.symmetry_to = "excellent"
            }
            if(params.clarity_from == baseFilter.clarity_from){
              baseParams.clarity_from = "fl"
            }
            if(params.clarity_to == baseFilter.clarity_to){
              baseParams.clarity_to = "if"
            }
            if(params.polish_from == baseFilter.polish_from){
              baseParams.polish_from = "excellent"
            }
            if(params.polish_to == baseFilter.polish_to){
              baseParams.polish_to = "excellent"
            }
            **/
          }else{
            this.clearFilterTag();
            if (this.$store.diamond.type == "natural"){
              this.filter = Object.assign(this.filter, {
                carat_from: "0.90",
                carat_to: "2.5",
                color_from: "d",
                color_to: "h",
                clarity_from: "if",
                clarity_to: "si1"
              });
            }

            if (this.$store.diamond.type == "lab" && !this.$store.diamond.is_colored){
              this.filter = Object.assign(this.filter, {
                carat_from: "1.4",
                carat_to: "8.0",
                color_from: "d",
                color_to: "f",
                clarity_from: "vvs1",
                clarity_to: "vs2"
              });
            }

            if (this.$store.diamond.type == "lab" && this.$store.diamond.is_colored){
               this.filter = Object.assign(this.filter, {
                carat_from: "1.2",
                carat_to: "2.5",
                clarity_from: "vvs1",
                clarity_to: "vs2"
              });
            }

          }
          this.reChangeRange()

        })
      },
      initSummary: function (event) {
        const summarys = document.querySelectorAll(selectors.summary);
        summarys.forEach((el) => {
          el.addEventListener("click", (event) => {
            summarys.forEach((item) =>
              item.classList.remove("summary-selected")
            );
            const selectedItem = event.target;
            selectedItem.classList.add("summary-selected");
            // this.summarySelected = selectedItem.innerText;
            if (selectedItem.dataset.value) {
              let order = {};
              if (selectedItem.dataset.value.includes("-")) {
                order.order_type = "desc";
              } else {
                order.order_type = "asc";
              }
              order.order_by = selectedItem.dataset.value.replace("-", "");
              this.order = order;
            } else {
              this.order = {
              };
            }
          });
        });
      },
      initDrawer: function () {
        if (!this.initDrawerBoolean && window.innerWidth < 768) {
          // this.$store.diamond.observer.observe(
          //   document.querySelector(
          //     ".collection-filter__item--btn.mobile-only svg"
          //   )
          // );
          this.openFilter = false;
          this.initDrawerBoolean = true;
          let drawerBtns = document.querySelectorAll(
            ".collection-sidebar button[data-drawer-name]"
          );
          drawerBtns.forEach((el) => {
            el.addEventListener("click", (event) => {
              this.filterName = el.dataset.drawerName;
            });
          });
        }
      },
      initRange() {
        const rangeEls = document.querySelectorAll(selectors.range);
        rangeEls.forEach((el) => {
          const sliderEl = el.querySelector(".range__slider");
          const type = el.dataset.type;
          const minValue =
            "int" == type
              ? parseInt(el.dataset.minValue)
              : parseFloat(el.dataset.minValue);
          const maxValue =
            "int" == type
              ? parseInt(el.dataset.maxValue)
              : parseFloat(el.dataset.maxValue);
          const minName = el.dataset.minName;
          const maxName = el.dataset.maxName;
          const step =
            "int" == type
              ? parseInt(el.dataset.step)
              : parseFloat(el.dataset.step);
          const dataValues = el.dataset.values ? eval(el.dataset.values) : [];
          if (el.dataset.min) {
            el.querySelector(".range__display-min").innerText = el.dataset.min;
            el.querySelector(".range__display-max").innerText = el.dataset.max;
          } else if (dataValues) {
            dataValues.forEach((itemValue) => {
              el.querySelector(
                ".range__display-wrapper-values"
              ).insertAdjacentHTML(
                "beforeend",
                "<span>" + itemValue + "</span>"
              );
            });
          }
          if (
            sliderEl &&
            sliderEl.noUiSlider &&
            typeof sliderEl.noUiSlider.destroy === "function"
          ) {
            sliderEl.noUiSlider.destroy();
          }
          const startFilter = this.filter[minName]?dataValues.length > 0 ? dataValues.indexOf(this.filter[minName]):this.filter[minName] :minValue;
          const endFilter = this.filter[maxName]?dataValues.length > 0 ? dataValues.indexOf(this.filter[maxName]):this.filter[maxName]:maxValue;
          var slider = noUiSlider.create(sliderEl, {
            connect: true,
            step: step,
            ...{},
            // Do not allow overriding these options
            start: [startFilter, endFilter],
            range: {
              min: minValue,
              max: maxValue,
            },
          });

          slider.on("update", (values) => {
            this.filter[minName] =
              "int" == type
                ? dataValues[parseInt(values[0])]
                  ? dataValues[parseInt(values[0])]
                  : parseInt(values[0])
                : values[0];
            this.filter[maxName] =
              "int" == type
                ? dataValues[parseInt(values[1])]
                  ? dataValues[parseInt(values[1])]
                  : parseInt(values[1])
                : values[1];
          });
        });
      },
      loadVideo: function(product) {
        if(product.video_url){
          product.showVideo = true
        }
        const gridProduct = document.querySelector(".grid-product[data-product-id='"+product.id+"']");
        if(gridProduct && gridProduct.querySelector("video")){
          try{
            gridProduct.querySelector("video").play()
          }catch(e){
            
          }
        }
      },
      unloadVideo: function(product){
        product.showVideo = false
        const gridProduct = document.querySelector(".grid-product[data-product-id='"+product.id+"']");
        if(gridProduct && gridProduct.querySelector("video")){
          try{
            gridProduct.querySelector("video").pause()
          }catch(e){
            
          }
        }
      },
      getList: function (isMerge) {
        if (!isMerge) {
          this.page = { page: 1, max_results: 24 };
        }
        let params = JSON.parse(JSON.stringify(this.filter));




        if (this.$store.diamond.is_colored) {
          delete params.color_from;
          delete params.color_to;
          if(params.colors.length == 0){
            params.colors = [
              "yellow/orange",
              "pink",
              "blue",
              "green",
              "blue-green",
              "brown",
              "orange-pink"]
          }
        } else {
          delete params.colors;
        }

        params = Object.assign(params, this.page);
        params = Object.assign(params, this.order);
        params.type = this.$store.diamond.type;
        // params.is_colored = this.$store.diamond.is_colored;




        this.total_items = "-"
        if (this.listAbortController) {
          this.listAbortController.abort();
        }
        this.listAbortController = new AbortController();
        const signal = this.listAbortController.signal;
        fetch(apiUrl + "/api/diamonds", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-api-key": apiKey,
          },
          body: JSON.stringify(params),
          signal,
        })
          .then((response) => response.json())
          .then((responseJson) => {
            var res = responseJson.response;

            if (res.code && res.code == 200) {
              let items = res.items;
              items.forEach(temp => {
                if(temp.video_url.indexOf('loupe360.com') > -1){
                  const params = temp.video_url.split("?")[1]
                  const urls = temp.video_url.split("?")[0].split("/video/")
                  const gridResults =  document.querySelector(".grid-results");
                  if(urls.length > 0 && gridResults){
                    let width = gridResults.clientWidth/2
                    if(window.screen.width > 767){
                       width = (gridResults.clientWidth - 60)/4
                    }
                    temp.video_url = urls[0] +"/video/"+ width+"/"+ width+"?"+params[1]
                  }
                }
              })
              if (isMerge) {
                this.data = this.data.concat(items);
              } else {
                this.data = items;
              }
              this.total_items = res.total_items;
              this.$refs.progress.style.width =
                ((this.data.length / this.total_items) * 100).toFixed(2) + "%";
            }else{
            }
            this.$nextTick(() => {
              this.$refs.diamonds.classList.remove("loading");

              // this.loadVideo()
            });
          })
          .catch((err) => {
            if (err.name === "AbortError") return;
            console.log(err);
          });
      },
    };
  };

  window["ThemeSection_DiamondView"] = (settings) => {
    if (settings.api_endpoint == "live") {
      (apiUrl = "https://kavalri-app.herokuapp.com"),
        (apiKey = "hamei3983jhPIhq7hLJo93hqmvNoC762");
    }

    return {
      diamondId: new URLSearchParams(window.location.search).get("id"),
      diamondItem: {},
      flickity: {},
      loading: true,
      init() {
        fetch(basePageURL + "?view=diamond-view-ajax", {
          method: "GET",
          headers: {
            "Content-Type": "text/html",
            Accept: "text/html",
          },
        }).then(response => response.text()).then(htmlContent => {
           const parser = new DOMParser();
           const doc = parser.parseFromString(htmlContent, "text/html");
           const target =  document.querySelector(".page-diamond-preview .reviews");
           target.parentNode.insertBefore(doc.querySelector(".step-by-step-video--section"), target);
        }).catch(error => {
        });
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('path') === 'express') {
          this.$store.diamond.express = true
           if(localStorage.getItem("diamond-selected-left-item")){
            this.$store.diamond.step = 21
          }else{
            this.$store.diamond.step = 2 
          }
        }else{
          this.$store.diamond.step = 1;
        }
        this.getDetail();


         this.$watch("$store.diamond.selectedItem", (value)=>{
          if(value.tags && value.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.diamond.showOtherStep = true;
          }
        });
        if(this.$store.diamond.selectedItem){
          const selectedItem = this.$store.diamond.selectedItem
          if(selectedItem.tags && selectedItem.tags.toLowerCase().indexOf("toietmoi")>-1){
            this.$store.diamond.showOtherStep = true;
          }
        }
      },
      bookConsultation: function() {
        const book_header_btn = document.querySelector(".book-appointment-header-btn");
        book_header_btn?book_header_btn.click():""
      },
      getDetail: function () {
        if (!this.diamondId) {
          this.$store.diamond.redirectURL(1, basePageURL);
        }
        fetch(apiUrl + "/api/diamonds/" + this.diamondId, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-api-key": apiKey,
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            var res = responseJson.response;
            if (res.code == 200) {
              var item = res.item;
              if (item.video_url && document.body.clientWidth < 500) {
                item.video_url = item.video_url.replace(
                  "500/500",
                  document.body.clientWidth + "/" + document.body.clientWidth
                );
              }
              this.diamondItem = item;
              this.loading = false;
              this.$nextTick(() => {
                this.initPhotos();
                this.initIframe();
                const video_container = document.querySelector(".image-wrap .video");
                if(item.video_url.indexOf('dia360') == -1 && item.video_url.indexOf('.jsp') == -1 && item.video_url.indexOf('.html') == -1 && item.video_url.indexOf('.php') == -1 &&  item.video_url.indexOf('ddpl.com') == -1 &&  item.video_url.indexOf('3dvirtualdiamond.com') == -1 &&  item.video_url.indexOf('loupe360.com') == -1 && item.video_url.indexOf('dia360.cloud') == -1){
                  video_container.innerHTML = '<video playsinline="true" autoplay="autoplay" loop="loop" muted="muted" preload="auto" ><source src="'+item.video_url+'" type="video/mp4"></video>'
                }
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            alert(err)
          });
      },
      initIframe: function () {
      },
      initPhotos: function () {
        const diamondDocument = this.$refs.diamond;
        // Initialize filter
        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: 0,
          childNav: diamondDocument.querySelector("[data-product-thumbs]"),
          childNavScroller: diamondDocument.querySelector(
            ".product__thumbs--scroller"
          ),
          childVertical: true,
          pageDots: true,
          wrapAround: true,
          cellAlign: "left",
          prevNextButtons: true,
        };
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        this.flickity = new theme.Slideshow(
          diamondDocument.querySelector("[data-product-photos]"),
          mainSliderArgs
        );

        var container = diamondDocument.querySelector("[data-product-images]");

        var imageZoom = new theme.Photoswipe(container, "gemstone");
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            this.flickity.goToSlide(evt.detail.index);
          }.bind(this)
        );
      },
    };
  };

  window["ThemeSection_RingList"] = (settings) => {
    if (settings.api_endpoint == "live") {
      (apiUrl = "https://kavalri-app.herokuapp.com"),
        (apiKey = "hamei3983jhPIhq7hLJo93hqmvNoC762");
    }

    return {
      summaryOpen: false,
      openFilter: true,
      filterName: "",
      flickity: {},
      initDrawerBoolean: false,
      loadPage(event) {
        let hrefStr = event.target.closest("a").getAttribute("href");
        this.$store.diamond.redirectURL(2, hrefStr, "list");
      },
      sortBy(sortBy) {
        this.summaryOpen = false;
        document.querySelector(selectors.filterFormSortBy).value = sortBy;
        this.$refs.filterForm.dispatchEvent(new Event("input"));
      },
      onFormSubmit(evt) {
        var el = evt.target;
        const parent = el.closest("li");
        const formEl = el.closest("form");
        const formData = new FormData(formEl);
        const searchParams = new URLSearchParams(formData);
        this.$store.diamond.redirectURL(
          2,
          collectionURL + "?" + "&" + searchParams.toString(),
          "view"
        );
      },
      drawerOpen() {
        // remove is-open
        this.$refs.filterForm
          .querySelectorAll(".is-open")
          .forEach((openItem) => {
            $(openItem).trigger("click.collapsible");
            this.filterName = "";
          });
        document.querySelector("html").classList.add("filter-drawer-open");
      },
      drawerClose() {
        document.querySelector("html").classList.remove("filter-drawer-open");
      },

      initDrawer: function () {
        if (!this.initDrawerBoolean && window.innerWidth < 768) {
          this.openFilter = false;
          this.initDrawerBoolean = true;
          let drawerBtns = this.$refs.filterForm.querySelectorAll(
            ".collection-sidebar button[data-drawer-name]"
          );
          drawerBtns.forEach((el) => {
            el.addEventListener("click", (event) => {
              this.filterName = el.dataset.drawerName;
            });
          });
        }
      },
      renderFromFormData(){
        this.$refs.filterForm.dispatchEvent(new Event("input"));
      },
      init() {
        this.$store.diamond.step = 2;

        window.onload = function () {
          window.StampedFn.loadDisplayWidgets();
        };
        this.filterName = "";
        this.drawerClose();
        theme.collapsibles.init();
        
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
        document
          .querySelectorAll(selectors.filterFormLabel)
          .forEach((label) => {
            label.addEventListener("click", (event) => {
              event.preventDefault();
              var checkboxes = label.querySelectorAll(".tag__input");
              checkboxes.forEach(function (checkbox) {
                checkbox.checked = !checkbox.checked;
              });
              this.$refs.filterForm.dispatchEvent(new Event("input"));
            });
          });
        this.$refs.filterForm.addEventListener(
          "input",
          this.onFormSubmit.bind(this)
        );
        this.$store.diamond.observer.observe(
          document.querySelector(
            "#CollectionAjaxContent .collection-filter__item--btn.mobile-only svg"
          )
        );
        this.$nextTick(() => {
          this.initDrawer();
        });
        window.on("resize", theme.utils.debounce(500, this.initDrawer));
      },
      selectAll() {
        if (this.filterName) {
          const checkboxs = this.$refs.filterForm
            .querySelector(
              '.collection-sidebar button[data-drawer-name="' +
                this.filterName +
                '"]'
            )
            .closest(".collection-sidebar__group")
            .querySelectorAll('input[type="checkbox"]:not(:checked)');
          checkboxs.forEach(function (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event("change"));
          });
        }
      },

      clearFilter: function () {
        let drawerBtn = this.$refs.filterForm.querySelector(
          '.collection-sidebar button[data-drawer-name = "' +
            this.filterName +
            '"]'
        );
        $(drawerBtn).trigger("click.collapsible");
        this.filterName = "";
      },
      clearFilterTag() {
        this.$store.diamond.redirectURL(2, collectionURL, "list");
      },
      loadProduct(event) {
        if (!this.$store.diamond.selectedItem.variant_id) {
          alert("Please select a diamond.");
          return;
        }
        const aTarget = event.target.closest(".grid-product__link");
        const hrefStr = aTarget.getAttribute("href");
        const product = JSON.parse(aTarget.dataset.product);
        localStorage.setItem("diamond-collection-href", window.location.href);

        this.$store.diamond.redirectURL(2, hrefStr, "view");
      },
    };
  };

  window["ThemeSection_RingView"] = (settings) => {
    if (settings.api_endpoint == "live") {
      (apiUrl = "https://kavalri-app.herokuapp.com"),
        (apiKey = "hamei3983jhPIhq7hLJo93hqmvNoC762");
    }

    return {
      init() {
        this.$store.diamond.step = 2;
      },

      loadCollection: function () {
        window.location.href = localStorage.getItem("diamond-collection-href");
      },
    };
  };
});

// Adjust mobile filter
 function updateProductMain() {
        const grid = document.getElementById("mobile-product-main__grid");
        const table = document.getElementById("mobile-product-main__table");
    
        if (window.getComputedStyle(grid).display === "none") {
            return table;
        } 
        if (window.getComputedStyle(table).display === "none") {
            return grid;
        }
        
        return grid; 
    }

  const scrollButton = document.getElementById("cust-scroll-button");
  const showFilterButton = document.querySelector(".cust-show__filters:has(#cust-show-filter)");
  const filterSection = document.getElementById("filterMain");

  showFilterButton.addEventListener("click", () => {
      filterSection.style.display = "block";  
      showFilterButton.style.display = "none";  
      scrollButton.style.display = "block"; 
  });

  window.addEventListener("scroll", () => {
      const productMain = updateProductMain();
      const scrollY = window.scrollY;
      const productTop = productMain.offsetTop;
      const filterTop = filterSection.offsetTop;
      const filterBottom = filterTop + filterSection.offsetHeight;
      const productBottom = productTop + productMain.offsetHeight;
 // scrollY >= productTop - 10
      if (scrollY >= filterBottom) {
          scrollButton.textContent = "Back to Filters";
         // scrollY <= filterTop + 10
      } else if (scrollY <= filterBottom - 100) {
          scrollButton.textContent = "Go to Results";
      }
    
      if (scrollY > productBottom) {
          scrollButton.style.display = "none";
      } else if(scrollY < productBottom) {
        if (showFilterButton.style.display === "none") { 
            scrollButton.style.display = "block";
        }
      }
  });

scrollButton.addEventListener("click", () => {
    const productMain = updateProductMain();
    let targetId = "";

    if (scrollButton.textContent === "Back to Filters") {
        targetId = "filterMain";
    } else {
        targetId = productMain.id;
    }

    history.pushState(null, null, `#${targetId}`);

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        let scrollTop = targetElement.offsetTop;

        if (targetElement.id !== "filterMain") {
            scrollTop -= 70;
        }else{
            scrollTop += 70;
        }

        window.scrollTo({
            top: scrollTop,
            behavior: "smooth"
        });
    }
});

